import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'

export const audienceRegistered: CaseReducer<NinchatState> = (state) => state
